import { TRADE_LOAN_BALANCE, TRADE_LOAN_CONFIRMATION } from '@makemydeal/dr-activities-tradein';
import type { SciTradeInComponentState } from '../types/TradeInState';
import { LOAN_FLOW_ROUTES } from '../constants';

export const isLoanStepRoute = (route?: string): boolean => route === TRADE_LOAN_BALANCE || route === TRADE_LOAN_CONFIRMATION;

export const isInLoanFlowRoute = (route?: string): boolean => !!route && LOAN_FLOW_ROUTES.includes(route);

export const isNoLoanAnswer = (state: SciTradeInComponentState, amountOwed: number): boolean =>
    !!state.loanStepPending && state.currentUserLocationRoute === TRADE_LOAN_BALANCE && amountOwed === 0;

export const isLoanConfirmationAnswer = (state: SciTradeInComponentState): boolean =>
    !!state.loanStepPending && state.currentUserLocationRoute === TRADE_LOAN_CONFIRMATION;
